import Swal from "sweetalert2";

export default {
  emptySelectOptionText: "-- не выбрано --",
  validatorMessageEmpty: "Введите данные",
  pageSize: 10,
  messengerFileLimit: 10,
  messengerFileMaxSize: 4 * 1048576,//4мб
  countryRussiaId: 185,//Россия
  regionNizhnyNovgorodId: 52, //Нижний Новгород
  confirmOptions: {
    delete: {
      title: "Удаление",
      text: "Вы действительно хотите удалить эту запись?",
      confirmButtonText: "Удалить",
      cancelButtonText: "Отмена",
      showCancelButton: true,
      icon: "warning",
    },
  },
  searchTooltip: "Поиск осуществляется по ФИО ребенка и представителя, паспортным данным, свидетельству, страховке, снилсу ребенка, телефону",
  commonError: "Произошла ошибка. Обратитесь в техническую поддержку.",
  select2Settings: {
    language: "ru",
  },
  yesNoList: [
    {
      id: null,
      text: "Не выбрано",
    },
    {
      id: true,
      text: "Да",
    },
    {
      id: false,
      text: "Нет",
    },
  ],
  phoneInputMask: "+7 (99999) 999-99",
  fiasApiUrl: "/api/fias/search",
  KindActivityEducation: 3,
  AdminRoleId: "1",
  SystemDialogType: 1,
  SystemDialogId: 1,
  CuratorDialogType: 2,
  // Permission IDs
  RoleView: 1,
  RoleEdit: 2,
  RmisDictionaryEdit: 4,
  LoginMobilePatient: 5,
  LoginMobileOrg: 6,
  RouteView: 39,
  RouteEdit: 40,
  OrganizationView: 41,
  OrganizationEdit: 42,
  PatientView: 44,
  PatientEdit: 45,
  PMPKView: 48,
  PMPKEdit: 49,
  IPRAView: 50,
  IPRAEdit: 51,
  MedServiceView: 52,
  MedServiceEdit: 53,
  IPPSUView: 54,
  IPPSUEdit: 55,
  JournalImarView: 56,
  JournalImarEdit: 57,
  JournalDiagnosticView: 58,
  JournalDiagnosticEdit: 59,
  JournalImarApprove: 60,
  JournalRouteView: 61,
  JournalRouteEdit: 62,
  OrganizationRoleView: 63,
  OrganizationRoleEdit: 64,
  PermissionsView: 65,
  PermissionsEdit: 66,
  UserView: 67,
  UserEdit: 68,
  JournalDiagnosticApprove: 69,
  JournalDiagnosticAssign: 70,
  DictionaryEdit: 72,
  RepresentativeEdit: 74,
  VacancyView: 77,
  VacancyEdit: 78,
  PollView: 81,
  PollEdit: 82,
  ViewSystemMessages: 83,
  GeneralQuestionsChat: 84,
  OrgServicesChat: 85,
  ReportPatientRegistry: 86,
  ReportGroupOfRisk: 87,
  ReportRouting: 88,
  ReportServiceProviders: 89,
  ReportEmployment: 90,
  OrganVlastiView: 92,
  OrganVlastiEdit: 93,
  CanEditOnlyOwnOrgVlasti: 94,
  DiagnosesView: 95,
  DiagnosesEdit: 96,
  TmpPatientView: 97,
  EditSnils: 98,
  SettingsAccess: 102,
  NewsCreate: 103,
  NewsUpdate: 104,
  NewsDelete: 105,
  ManualEdit: 106,
  JournalImarFinish: 99,
  TmpPatientEdit: 100,
  DashboardView: 101,
  JournalImarSpecialDelete: 111,
  JournalImarSpecialEdit: 112,
  JournalImarSpecialDeleteAfterStep1: 113,
  JournalImarSpecialEditAfterStep1: 114,
  JournalImarSpecialDeleteAfterStep2: 115,
  JournalImarSpecialEditAfterStep2: 116,
  PatientCommentEdit: 117,
  PatientDeletePermanentlyView: 118,

  passwordValidationErrorsRU: [
    {
      code: "PasswordMismatch",
      descriptionRU: "Некорректно введен старый пароль",
    },
    {
      code: "PasswordLengthMismatch",
      descriptionRU: "Длина пароля должна быть не менее 6 символов",
    },
    {
      code: "PasswordTooShort",
      descriptionRU: "Длина пароля должна быть не менее 6 символов",
    },
    {
      code: "PasswordRequiresUpper",
      descriptionRU: "Пароль должен содержать хоть одну заглавную букву",
    },
    {
      code: "PasswordRequiresLower",
      descriptionRU: "Пароль должен содержать хоть одну строчную букву",
    },
    {
      code: "PasswordRequiresNonAlphanumeric",
      descriptionRU:
        "Пароль должен содержать хоть один небуквенно-цифровой символ (!,?)",
    },
    {
      code: "NoDigits",
      descriptionRU: "Пароль должен содержать хоть одну цифру",
    },
    {
      code: "PasswordRequiresDigit",
      descriptionRU: "Пароль должен содержать хоть одну цифру",
    },
  ],

  alert: Swal.mixin({
    //customClass: {
    //  confirmButton: 'btn btn-success',
    //  cancelButton: 'btn btn-danger'
    //},
    //buttonsStyling: false
  }),
  removeFromArr(arr) {
    var what,
      a = arguments,
      L = a.length,
      ax;
    while (L > 1 && arr.length) {
      what = a[--L];
      while ((ax = arr.indexOf(what)) !== -1) {
        arr.splice(ax, 1);
      }
    }
    return arr;
  },
  mapSearchApiKey: "b3QFOWTvWMzAGgOc2ETIBIuOa8dcWSAFeQV5nh7xY74",
};
